var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionIconThickBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5C3.1423 0.5 0 3.6423 0 7.5C0 11.3577 3.1423 14.5 7 14.5C10.8577 14.5 14 11.3577 14 7.5C14 3.6423 10.8577 0.5 7 0.5ZM7 1.9C10.1011 1.9 12.6 4.39891 12.6 7.5C12.6 10.6011 10.1011 13.1 7 13.1C3.89891 13.1 1.4 10.6011 1.4 7.5C1.4 4.39891 3.89891 1.9 7 1.9ZM7 3.3C5.453 3.3 4.2 4.553 4.2 6.1H5.6C5.6 5.33 6.23 4.7 7 4.7C7.77 4.7 8.4 5.33 8.4 6.1C8.4 7.5 6.3 7.7569 6.3 9.6H7.7C7.7 8.4443 9.8 7.85 9.8 6.1C9.8 4.553 8.547 3.3 7 3.3ZM6.3 10.3V11.7H7.7V10.3H6.3Z",
    fill: "#131314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIconThickBlack);
export default __webpack_public_path__ + "static/media/question-icon-thick-black.facd668b5829649240b72e69f9ea5774.svg";
export { ForwardRef as ReactComponent };